export default [
  {
    code: 'O1',
    name: 'Other regions',
  },
  {
    code: 'UA',
    name: 'Ukraine',
  },
  {
    code: 'RU',
    name: 'Russian Federation',
  },
  {
    code: 'DE',
    name: 'Germany',
  },
  {
    code: 'US',
    name: 'United States',
  },
  {
    code: 'KZ',
    name: 'Kazakhstan',
  },
  {
    code: 'IL',
    name: 'Israel',
  },
  {
    code: 'BY',
    name: 'Belarus',
  },
  {
    code: 'LV',
    name: 'Latvia',
  },
  {
    code: 'MD',
    name: 'Republic of Moldova',
  },
  {
    code: 'EE',
    name: 'Estonia',
  },
  {
    code: 'LT',
    name: 'Lithuania',
  },
  {
    code: 'CA',
    name: 'Canada',
  },
  {
    code: 'RO',
    name: 'Romania',
  },
  {
    code: 'GB',
    name: 'United Kingdom',
  },
  {
    code: 'GE',
    name: 'Georgia',
  },
  {
    code: 'CZ',
    name: 'Czech Republic',
  },
  {
    code: 'AZ',
    name: 'Azerbaijan',
  },
  {
    code: 'ES',
    name: 'Spain',
  },
  {
    code: 'PL',
    name: 'Poland',
  },
  {
    code: 'FR',
    name: 'France',
  },
  {
    code: 'TR',
    name: 'Turkey',
  },
  {
    code: 'IT',
    name: 'Italy',
  },
  {
    code: 'UZ',
    name: 'Uzbekistan',
  },
  {
    code: 'FI',
    name: 'Finland',
  },
  {
    code: 'IE',
    name: 'Ireland',
  },
  {
    code: 'CN',
    name: 'China',
  },
  {
    code: 'BG',
    name: 'Bulgaria',
  },
  {
    code: 'GR',
    name: 'Greece',
  },
  {
    code: 'SE',
    name: 'Sweden',
  },
  {
    code: 'AM',
    name: 'Armenia',
  },
  {
    code: 'BE',
    name: 'Belgium',
  },
  {
    code: 'NL',
    name: 'Netherlands',
  },
  {
    code: 'NO',
    name: 'Norway',
  },
  {
    code: 'AU',
    name: 'Australia',
  },
  {
    code: 'PT',
    name: 'Portugal',
  },
  {
    code: 'AT',
    name: 'Austria',
  },
  {
    code: 'CH',
    name: 'Switzerland',
  },
  {
    code: 'KR',
    name: 'Republic of Korea',
  },
  {
    code: 'HU',
    name: 'Hungary',
  },
  {
    code: 'KG',
    name: 'Kyrgyzstan',
  },
  {
    code: 'JP',
    name: 'Japan',
  },
  {
    code: 'DK',
    name: 'Denmark',
  },
  {
    code: 'AE',
    name: 'United Arab Emirates',
  },
  {
    code: 'AR',
    name: 'Argentina',
  },
  {
    code: 'BR',
    name: 'Brazil',
  },
  {
    code: 'MX',
    name: 'Mexico',
  },
  {
    code: 'SK',
    name: 'Slovakia',
  },
  {
    code: 'TJ',
    name: 'Tajikistan',
  },
  {
    code: 'EG',
    name: 'Egypt',
  },
  {
    code: 'VN',
    name: 'Viet Nam',
  },
  {
    code: 'CY',
    name: 'Cyprus',
  },
  {
    code: 'IN',
    name: 'India',
  },
  {
    code: 'MY',
    name: 'Malaysia',
  },
  {
    code: 'TH',
    name: 'Thailand',
  },
  {
    code: 'NZ',
    name: 'New Zealand',
  },
  {
    code: 'ZA',
    name: 'South Africa',
  },
  {
    code: 'PK',
    name: 'Pakistan',
  },
  {
    code: 'AD',
    name: 'Andorra',
  },
  {
    code: 'AF',
    name: 'Afghanistan',
  },
  {
    code: 'AG',
    name: 'Antigua and Barbuda',
  },
  {
    code: 'AL',
    name: 'Albania',
  },
  {
    code: 'AO',
    name: 'Angola',
  },
  {
    code: 'BA',
    name: 'Bosnia and Herzegovina',
  },
  {
    code: 'BB',
    name: 'Barbados',
  },
  {
    code: 'BD',
    name: 'Bangladesh',
  },
  {
    code: 'BF',
    name: 'Burkina Faso',
  },
  {
    code: 'BH',
    name: 'Bahrain',
  },
  {
    code: 'BI',
    name: 'Burundi',
  },
  {
    code: 'BJ',
    name: 'Benin',
  },
  {
    code: 'BM',
    name: 'Bermuda',
  },
  {
    code: 'BN',
    name: 'Brunei Darussalam',
  },
  {
    code: 'BO',
    name: 'Plurinational State of Bolivia',
  },
  {
    code: 'BS',
    name: 'Bahamas',
  },
  {
    code: 'BT',
    name: 'Bhutan',
  },
  {
    code: 'BW',
    name: 'Botswana',
  },
  {
    code: 'BZ',
    name: 'Belize',
  },
  {
    code: 'CD',
    name: 'The Democratic Republic of the Congo',
  },
  {
    code: 'CF',
    name: 'Central African Republic',
  },
  {
    code: 'CG',
    name: 'Congo',
  },
  {
    code: 'CI',
    name: 'Cote D Ivoire',
  },
  {
    code: 'CL',
    name: 'Chile',
  },
  {
    code: 'CM',
    name: 'Cameroon',
  },
  {
    code: 'CO',
    name: 'Colombia',
  },
  {
    code: 'CR',
    name: 'Costa Rica',
  },
  {
    code: 'CU',
    name: 'Cuba',
  },
  {
    code: 'CV',
    name: 'Cape Verde',
  },
  {
    code: 'DJ',
    name: 'Djibouti',
  },
  {
    code: 'DM',
    name: 'Dominica',
  },
  {
    code: 'DO',
    name: 'Dominican Republic',
  },
  {
    code: 'DZ',
    name: 'Algeria',
  },
  {
    code: 'EC',
    name: 'Ecuador',
  },
  {
    code: 'ER',
    name: 'Eritrea',
  },
  {
    code: 'ET',
    name: 'Ethiopia',
  },
  {
    code: 'FJ',
    name: 'Fiji',
  },
  {
    code: 'FM',
    name: 'Federated States of Micronesia',
  },
  {
    code: 'GA',
    name: 'Gabon',
  },
  {
    code: 'GD',
    name: 'Grenada',
  },
  {
    code: 'GH',
    name: 'Ghana',
  },
  {
    code: 'GL',
    name: 'Greenland',
  },
  {
    code: 'GM',
    name: 'Gambia',
  },
  {
    code: 'GN',
    name: 'Guinea',
  },
  {
    code: 'GQ',
    name: 'Equatorial Guinea',
  },
  {
    code: 'GT',
    name: 'Guatemala',
  },
  {
    code: 'GW',
    name: 'Guinea-Bissau',
  },
  {
    code: 'GY',
    name: 'Guyana',
  },
  {
    code: 'HN',
    name: 'Honduras',
  },
  {
    code: 'HR',
    name: 'Croatia',
  },
  {
    code: 'HT',
    name: 'Haiti',
  },
  {
    code: 'ID',
    name: 'Indonesia',
  },
  {
    code: 'IQ',
    name: 'Iraq',
  },
  {
    code: 'IR',
    name: 'Islamic Republic of Iran',
  },
  {
    code: 'IS',
    name: 'Iceland',
  },
  {
    code: 'JM',
    name: 'Jamaica',
  },
  {
    code: 'JO',
    name: 'Jordan',
  },
  {
    code: 'KE',
    name: 'Kenya',
  },
  {
    code: 'KH',
    name: 'Cambodia',
  },
  {
    code: 'KI',
    name: 'Kiribati',
  },
  {
    code: 'KM',
    name: 'Comoros',
  },
  {
    code: 'KN',
    name: 'Saint Kitts and Nevis',
  },
  {
    code: 'KP',
    name: 'Democratic Peoples Republic of Korea',
  },
  {
    code: 'KW',
    name: 'Kuwait',
  },
  {
    code: 'KY',
    name: 'Cayman Islands',
  },
  {
    code: 'LA',
    name: 'Lao Peoples Democratic Republic',
  },
  {
    code: 'LB',
    name: 'Lebanon',
  },
  {
    code: 'LC',
    name: 'Saint Lucia',
  },
  {
    code: 'LI',
    name: 'Liechtenstein',
  },
  {
    code: 'LK',
    name: 'Sri Lanka',
  },
  {
    code: 'LR',
    name: 'Liberia',
  },
  {
    code: 'LS',
    name: 'Lesotho',
  },
  {
    code: 'LU',
    name: 'Luxembourg',
  },
  {
    code: 'LY',
    name: 'Libya',
  },
  {
    code: 'MA',
    name: 'Morocco',
  },
  {
    code: 'MC',
    name: 'Monaco',
  },
  {
    code: 'MG',
    name: 'Madagascar',
  },
  {
    code: 'MK',
    name: 'The Former Yugoslav Republic of Macedonia',
  },
  {
    code: 'ML',
    name: 'Mali',
  },
  {
    code: 'MM',
    name: 'Myanmar',
  },
  {
    code: 'MN',
    name: 'Mongolia',
  },
  {
    code: 'MO',
    name: 'Macao',
  },
  {
    code: 'MR',
    name: 'Mauritania',
  },
  {
    code: 'MS',
    name: 'Montserrat',
  },
  {
    code: 'MU',
    name: 'Mauritius',
  },
  {
    code: 'MV',
    name: 'Maldives',
  },
  {
    code: 'MW',
    name: 'Malawi',
  },
  {
    code: 'MZ',
    name: 'Mozambique',
  },
  {
    code: 'NA',
    name: 'Namibia',
  },
  {
    code: 'NE',
    name: 'Niger',
  },
  {
    code: 'NG',
    name: 'Nigeria',
  },
  {
    code: 'NI',
    name: 'Nicaragua',
  },
  {
    code: 'NP',
    name: 'Nepal',
  },
  {
    code: 'NR',
    name: 'Nauru',
  },
  {
    code: 'OM',
    name: 'Oman',
  },
  {
    code: 'PA',
    name: 'Panama',
  },
  {
    code: 'PE',
    name: 'Peru',
  },
  {
    code: 'PG',
    name: 'Papua New Guinea',
  },
  {
    code: 'PH',
    name: 'Philippines',
  },
  {
    code: 'PS',
    name: 'Occupied Palestinian Territory',
  },
  {
    code: 'PY',
    name: 'Paraguay',
  },
  {
    code: 'QA',
    name: 'Qatar',
  },
  {
    code: 'RS',
    name: 'Serbia',
  },
  {
    code: 'RW',
    name: 'Rwanda',
  },
  {
    code: 'SA',
    name: 'Saudi Arabia',
  },
  {
    code: 'SB',
    name: 'Solomon Islands',
  },
  {
    code: 'SC',
    name: 'Seychelles',
  },
  {
    code: 'SD',
    name: 'Sudan',
  },
  {
    code: 'SH',
    name: 'Saint Helena',
  },
  {
    code: 'SI',
    name: 'Slovenia',
  },
  {
    code: 'SL',
    name: 'Sierra Leone',
  },
  {
    code: 'SM',
    name: 'San Marino',
  },
  {
    code: 'SN',
    name: 'Senegal',
  },
  {
    code: 'SO',
    name: 'Somalia',
  },
  {
    code: 'SR',
    name: 'Suriname',
  },
  {
    code: 'ST',
    name: 'Sao Tome and Principe',
  },
  {
    code: 'SV',
    name: 'El Salvador',
  },
  {
    code: 'SY',
    name: 'Syrian Arab Republic',
  },
  {
    code: 'SZ',
    name: 'Swaziland',
  },
  {
    code: 'TD',
    name: 'Chad',
  },
  {
    code: 'TG',
    name: 'Togo',
  },
  {
    code: 'TM',
    name: 'Turkmenistan',
  },
  {
    code: 'TN',
    name: 'Tunisia',
  },
  {
    code: 'TO',
    name: 'Tonga',
  },
  {
    code: 'TT',
    name: 'Trinidad and Tobago',
  },
  {
    code: 'TW',
    name: 'Taiwan',
  },
  {
    code: 'TZ',
    name: 'United Republic of Tanzania',
  },
  {
    code: 'UG',
    name: 'Uganda',
  },
  {
    code: 'UY',
    name: 'Uruguay',
  },
  {
    code: 'VC',
    name: 'Saint Vincent and the Grenadines',
  },
  {
    code: 'VE',
    name: 'Bolivarian Republic of Venezuela',
  },
  {
    code: 'VU',
    name: 'Vanuatu',
  },
  {
    code: 'WS',
    name: 'Samoa',
  },
  {
    code: 'YE',
    name: 'Yemen',
  },
  {
    code: 'ZM',
    name: 'Zambia',
  },
  {
    code: 'ZW',
    name: 'Zimbabwe',
  },
  {
    code: 'HK',
    name: 'Hong Kong',
  },
  {
    code: 'SG',
    name: 'Singapore',
  },
  {
    code: 'MT',
    name: 'Malta',
  },
  {
    code: 'RE',
    name: 'Reunion',
  },
  {
    code: 'YT',
    name: 'Mayotte',
  },
  {
    code: 'GF',
    name: 'French Guiana',
  },
  {
    code: 'GP',
    name: 'Guadeloupe',
  },
  {
    code: 'GU',
    name: 'Guam',
  },
  {
    code: 'ME',
    name: 'Montenegro',
  },
  {
    code: 'MQ',
    name: 'Martinique',
  },
  {
    code: 'NC',
    name: 'New Caledonia',
  },
  {
    code: 'PF',
    name: 'French Polynesia',
  },
  {
    code: 'PR',
    name: 'Puerto Rico',
  },
];
